import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa',
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: colors.green,
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es'
  },
})
